import { render, staticRenderFns } from "./Hospital.vue?vue&type=template&id=5988bd08&scoped=true"
import script from "./Hospital.vue?vue&type=script&lang=js"
export * from "./Hospital.vue?vue&type=script&lang=js"
import style0 from "./Hospital.vue?vue&type=style&index=0&id=5988bd08&prod&lang=css"
import style1 from "./Hospital.vue?vue&type=style&index=1&id=5988bd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5988bd08",
  null
  
)

export default component.exports